import React from 'react';
import AdminLayout from './AdminLayout';
import AdminDashboard from './AdminDashboard';

const AdminModule: React.FC = () => {
  return (
    <AdminLayout>
      <AdminDashboard activeTab="users" />
    </AdminLayout>
  );
};

export default AdminModule;